import AxiosInstance from "../instance";

const getFaceRestorationResult = async (payload: string) => {
    const response = await AxiosInstance.getInstance().post("/face-restoration", {"base64_encoded_image": payload});
    return response;
};

export {getFaceRestorationResult};


// WEBPACK FOOTER //
// ./src/api/models/FaceRestoration.ts